import { atom } from "recoil";

export const UniqueIdentifierState = atom<string>({
  key: "UniqueIdentifierState",
  default: "",
});

export const OverlayTriggerState = atom<string>({
  key: "OverlayTriggerState",
  default: "",
});

export const ViewLocationState = atom<string>({
  key: "ViewLocationState",
  default: "",
});

export const ViewSubLocationState = atom<string>({
  key: "ViewSubLocationState",
  default: "",
});

export const NotificationBannerCopyType = atom<string>({
  key: "NotificationBannerCopyType",
  default: "default",
});

export const ActiveOverlayPopUpState = atom<string | null>({
  key: "ActiveOverlayPopUpState",
  default: null,
});

export const PlatformState = atom<string | null>({
  key: "PlatformState",
  default: "",
});

export const KnownState = atom<boolean>({
  key: "KnownState",
  default: false,
});

export const NotificationBannerDisplayState = atom<boolean>({
  key: "NotificationBannerDisplayState",
  default: false,
});

export const TrackedFirstHoverState = atom<boolean>({
  key: "TrackedFirstHoverState",
  default: false,
});

export const ShouldDisplayOverlayState = atom<boolean>({
  key: "ShouldDisplayOverlayState",
  default: false,
});
